
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wiki/tools/[slug]",
      function () {
        return require("private-next-pages/wiki/tools/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wiki/tools/[slug]"])
      });
    }
  